import {
  initReportMultiDataSource,
  serializeQuery,
} from "helpers/service_helper"
import React, { useState, useEffect } from "react"
import { Button, Row, Col, Spin, Switch, Space } from "antd"
import { connect } from "react-redux"

import StiReport from "../../../../assets/reports/finance/ServiceReport.mrt"

import Localizations from "../../../../locales/fa/fa.xml"
import { getEngPaymentTask, getServiceReport } from "store/actions"
import { EngPaymentTaskList } from "./eng-payment-task-list"
import { loadStimulsoftScripts } from "helpers/stimulsoftLoader"
const Report = props => {
  const {
    lstServiceReport,
    loading,
    onGetServiceReport,
    lstEngPaymentTask,
  } = props

  const [insideLoading, setInsideLoading] = useState(false)
  const [engPaymentTaskId, setEngPaymentTaskId] = useState(null)

  // Helper to ensure Stimulsoft scripts are loaded before using initReport
  const ensureStimulsoftAndInit = async (reportData) => {
    await loadStimulsoftScripts()

    initReportMultiDataSource(StiReport, reportData, Localizations, {
      amir: "amir",
      test: 122,
    })
  }

  useEffect(() => {
    if (lstServiceReport.length > 0) {
      const reportData = {
        FinanceData: lstEngPaymentTask?.filter(x => x.id === engPaymentTaskId),
        FinanceList: lstServiceReport,
      }

      ensureStimulsoftAndInit(reportData, 0)
      setInsideLoading(false)

    }
  }, [lstServiceReport])

  const prepareReport = async () => {
    setInsideLoading(true)
    let searchQuery = {
      engPaymentTaskId,
    }
    const params = serializeQuery(searchQuery)
    if (!!engPaymentTaskId) await onGetServiceReport(params)
  }

  return (
    <>
      {loading && insideLoading && <Spin tip="Loading" size="large" />}

      <Row gutter={[8, 8]}>
        <Col>
          <EngPaymentTaskList
            selectEngPaymentTask={setEngPaymentTaskId}
            props={props}
          />
        </Col>
      </Row>
      <Space />
      <Button
        htmlType="button"
        onClick={async () => {
          await prepareReport()
        }}
      >
        گزارش گیری
      </Button>

      {lstServiceReport.length > 0 ? (
        <div style={{ maxWidth: "822px" }} id="viewer"></div>
      ) : (
        "رکوردی برای نمایش وجود ندارد مجددا گزارش گیری نمایید"
      )}
    </>
  )
}

const mapStateToProps = ({ FinanceReport, EngPayment }) => ({
  lstServiceReport: FinanceReport.lstServiceReport,
  error: FinanceReport.error,
  success: FinanceReport.success,
  loading: FinanceReport.loading,
  lstEngPaymentTask: EngPayment.lstEngPaymentTask,
})

const mapDispatchToProps = dispatch => ({
  onGetServiceReport: data => dispatch(getServiceReport(data)),
  onGetEngPaymentTasks: () => dispatch(getEngPaymentTask()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Report)
